export enum UserResourceField {
  id = 'id',
  uuid = 'uuid',
  name = 'name',
  help = 'help',
  email = 'email',
  surname = 'surname',
  priority = 'priority',
  createdAt = 'createdAt',
  legalEntityId = 'legalEntityId',
  privacyRoleId = 'privacyRoleId',
  organizationalFunctionId = 'organizationalFunctionId',
  employmentRelationshipId = 'employmentRelationshipId'
}
